import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a558e828"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "SearchSimple" }
const _hoisted_2 = ["placeholder"]

import store from "@/store";
import { nextTick, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import SearchSuggest from "../SearchSuggest.vue";
import axios from "axios";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchSimple',
  props: {
  placeholder: {
    type: String,
    default: "書名, ISBN, 著者名等を入力",
  },
},
  emits: ["onSearch"],
  setup(__props, { expose: __expose, emit: __emit }) {


const emit = __emit;
const route = useRoute();

onMounted(async () => {
  // 在庫照会の受注保留のクリックから遷移してきた場合、初期表示を書誌コードで絞り込む
  if (
    (route.path === "/orderHold" || route.path === "/orderOutOfStock") &&
    route.query.syosiCd !== undefined
  ) {
    searchWord.value = String(route.query.syosiCd);
    await nextTick();
    search();
  }
});

// 画面によってストアの値を保持しているので初期値としてセット
const initialWord = store.getters["search/getSearchSimpleState"];
const searchWord = ref(initialWord);
watch(searchWord, () => {
  // console.log("searchSimpleのwatch");
  store.commit("search/setSearchSimpleState", searchWord.value);
});

// const isStoreSimpleFlg = computed(() => {
//   return store.getters["search/getsearchSimpleFlg"];
// });
// const simpleFlg = ref(isStoreSimpleFlg.value);

const search = () => {
  emit("onSearch");
};

// orderHeaderから条件リセットボタンが押されたときに発火
const resetConditions = () => {
  searchWord.value = "";
};

// サジェスト用------------------------------------------------
let originSuggestData: string[] = [];
let suggestData = ref([...originSuggestData]);
const suggestVisible = ref(false);
// APIから履歴データ取得処理
const getSuggestData = async () => {
  const res = await axios.get(
    `${store.getters["getBaseUrl"]}/search/history/get	`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    }
  );
  originSuggestData = [...res.data];
};
getSuggestData();
// サジェスト表示処理
const showSuggest = async (e: any) => {
  // console.log(e.type);
  if (e.type === "focus") {
    await getSuggestData();
  }
  suggestData.value = [...originSuggestData];
  if (suggestData.value.length > 0) {
    if (searchWord.value === "") {
      suggestVisible.value = true;
    } else {
      let isPerfectMatching = false;
      let partialMatchIndexArray: number[] = [];
      for (const [index, suggest] of suggestData.value.entries()) {
        // 完全一致の判定
        if (suggest === searchWord.value) {
          isPerfectMatching = true;
        }
        // 部分一致するデータのindexを抜き出す
        let partialMatchIndex = suggest.indexOf(searchWord.value);
        if (partialMatchIndex !== -1) {
          partialMatchIndexArray.push(index);
        }
      }

      // 「完全一致かつ部分一致の候補が複数あり」or「完全一致なしかつ部分一致の候補あり」の場合、
      // サジェスト表示+候補絞り込み処理を行う
      if (
        (isPerfectMatching && partialMatchIndexArray.length > 1) ||
        (!isPerfectMatching && partialMatchIndexArray.length > 0)
      ) {
        suggestVisible.value = true;
        suggestData.value = suggestData.value.filter((value, index) => {
          return partialMatchIndexArray.indexOf(index) > -1;
        });
      } else {
        suggestVisible.value = false;
      }
    }
    await nextTick();
    creatMoveWithAllowElms();
  }
};
// サジェスト非表示
const hiddenSuggest = () => {
  setTimeout(() => {
    suggestVisible.value = false;
  }, 100);
};
// サジェスト選択時
const selectSuggest = (selectedSuggest: string) => {
  searchWord.value = selectedSuggest;
};
const selectSuggestByEnter = (selectedSuggest: string) => {
  searchWord.value = selectedSuggest;
  hiddenSuggest();
};

// サジェスト内の上下キー移動用-------------------------------------------
let moveWithAllowElms = ref([] as HTMLElement[]);
let focusedIndex = -1;
let focusLimit = 0;
// 上下キー移動用の要素グループ作成
const creatMoveWithAllowElms = async () => {
  focusedIndex = -1;
  const targetElms = document.getElementsByClassName(
    "Move_With_Allow"
    // eslint-disable-next-line no-undef
  ) as HTMLCollectionOf<HTMLElement>;
  moveWithAllowElms.value = [...targetElms];
  moveWithAllowElms.value.forEach((el) => {
    if (el.classList.contains("hoverd")) el.classList.remove("hoverd");
  });
  focusLimit = moveWithAllowElms.value.length - 1;
};
// downキークリック時
const moveNext = (event: any, elementsArray: HTMLElement[]) => {
  event.preventDefault();
  if (focusedIndex === -1) {
    focusedIndex = 0;
  } else if (focusedIndex === focusLimit) {
    elementsArray[focusLimit].classList.remove("hoverd");
    focusedIndex = 0;
  } else {
    elementsArray[focusedIndex].classList.remove("hoverd");
    focusedIndex++;
  }
  elementsArray[focusedIndex].classList.add("hoverd");
  scrollToSuggest(elementsArray[focusedIndex], "next");
};
// upキークリック時
const movePrev = (event: any, elementsArray: HTMLElement[]) => {
  event.preventDefault();
  if (focusedIndex === -1) {
    focusedIndex = focusLimit;
  } else if (focusedIndex === 0) {
    elementsArray[0].classList.remove("hoverd");
    focusedIndex = focusLimit;
  } else {
    elementsArray[focusedIndex].classList.remove("hoverd");
    focusedIndex--;
  }
  elementsArray[focusedIndex].classList.add("hoverd");
  scrollToSuggest(elementsArray[focusedIndex], "prev");
};
// サジェストの選択に合わせてスクロールを動かす
const scrollToSuggest = (targetElm: HTMLElement, behavior: string) => {
  const suggestElm = document.getElementsByClassName("SearchSimple_Suggest");
  const rect = targetElm.getBoundingClientRect();
  if (
    rect.top < suggestElm[0].getBoundingClientRect().top ||
    rect.bottom > suggestElm[0].getBoundingClientRect().bottom
  ) {
    if (behavior === "next") {
      suggestElm[0].scrollTop +=
        rect.bottom - suggestElm[0].getBoundingClientRect().bottom;
    } else {
      suggestElm[0].scrollTop +=
        rect.top - suggestElm[0].getBoundingClientRect().top;
    }
  }
};
// キークリック関連------------------------
const onKeyDown = (e: any) => {
  // console.log(e.key);
  // サジェスト用
  if (suggestVisible.value) {
    if (e.key === "ArrowDown" && !e.altKey && !e.ctrlKey && !e.shiftKey) {
      moveNext(e, moveWithAllowElms.value);
    } else if (e.key === "ArrowUp" && !e.altKey && !e.ctrlKey && !e.shiftKey) {
      movePrev(e, moveWithAllowElms.value);
    }
  }
};
onMounted(() => {
  document.addEventListener("keydown", onKeyDown);
});
// onBeforeUnmount(() => {
//   document.removeEventListener("keydown", onKeyDown);
// });

__expose({
  resetConditions,
  selectSuggestByEnter,
  getSuggestData,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "text",
      placeholder: __props.placeholder,
      class: "SearchSimple_Input",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchWord).value = $event)),
      onFocus: showSuggest,
      onClick: showSuggest,
      onInput: showSuggest,
      onBlur: hiddenSuggest
    }, null, 40, _hoisted_2), [
      [_vModelText, searchWord.value]
    ]),
    (suggestVisible.value)
      ? (_openBlock(), _createBlock(SearchSuggest, {
          key: 0,
          class: "SearchSimple_Suggest",
          suggestData: _unref(suggestData),
          onSelectSuggest: selectSuggest
        }, null, 8, ["suggestData"]))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      onClick: search,
      class: "SearchSimple_Button"
    }, "検索")
  ]))
}
}

})